(() => {
  if (window.sharpCustomFanTimingReady) return;
  window.sharpCustomFanTimingReady = true;
  // Actual option containers used by Hulk's storefront script, excluding cart hooks.
  const selector = '[id^="hulkapps_custom_options_"], [id^="hulkapps_options_"], .hulkapps_product_options, .hulkapps_option_set';
  const attach = () => {
    const template = document.getElementById('SharpCustomFanTimingTemplate');
    if (!template) return;
    document.querySelectorAll(selector).forEach(options => {
      if (!options.querySelector('input, select, textarea')) return;
      if (options.closest('#CartDrawer, cart-drawer, #cart-notification')) return;
      const scope = options.closest('product-info, .product__info-container, form, .shopify-section') || options.parentElement;
      if (scope.querySelector('[data-sharp-custom-fan-timing]')) return;
      const notice = template.content.firstElementChild.cloneNode(true);
      const outer = options.closest('[id^="hulkapps_custom_options_"]') || options;
      outer.before(notice);
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; attach(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  attach();
  document.addEventListener('shopify:section:load', attach);
})();
